export default {
  mainBackround: "white",
  footerBackground: "#e4e4e4",
  warning: "#e06b00",
  passed: "#00983f",
  failed: "#e01600"
};
